import { render, staticRenderFns } from "./Projectdetail.vue?vue&type=template&id=66f19f63"
import script from "./Projectdetail.vue?vue&type=script&lang=js"
export * from "./Projectdetail.vue?vue&type=script&lang=js"
import style0 from "./Projectdetail.vue?vue&type=style&index=0&id=66f19f63&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports